import * as stylex from '@stylexjs/stylex';
import clsx from 'clsx';
import _ from 'lodash';
import React from 'react';
import { Field, useForm } from 'react-final-form';
import { canUseMemo, getFormFieldProps, getValidationFunction } from '@/formbuilder/formbuilder.utilities';
import { ColorPicker } from '@/workbook/ColorPicker.organism';
import type { ValidatingFormComponent } from '@/formbuilder/formBuilder.types';

export interface ColorPickerIF extends ValidatingFormComponent<string> {
  swatchXstyle?: stylex.StyleXStyles;
  component: 'ColorPickerFormComponent';
  placement: string;
  color: string;
  colors: string[];
  itemId: number;
  notifyOnSelect?: (itemId: number, color: string) => void;
  dataTestId?: string;
}

const ColorPickerFormComponentUnwrapped = (props: ColorPickerIF) => {
  const { name, validation, extendValidation, extraClassNames } = props;

  const defaultValidation = (value: string | undefined) => _.isEmpty(value);
  const formState = useForm().getState();

  return (
    <Field name={name} validate={getValidationFunction(defaultValidation, extendValidation, validation)}>
      {({ input, meta }) => (
        <div {...stylex.props(props.xstyle)} className={clsx(stylex.props(props.xstyle).className, extraClassNames)}>
          <ColorPicker {...getFormFieldProps(formState, input, meta, props)} />
        </div>
      )}
    </Field>
  );
};

export const ColorPickerFormComponent = React.memo(ColorPickerFormComponentUnwrapped, canUseMemo);
